import React, { useState } from 'react'
import { Button, Popconfirm } from 'antd'
import { CustomModal, FootPrintForm } from 'src/components'
import styles from './FootPrintListActionColumn.module.scss'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { deleteFootPrint, updateFootPrint } from 'src/features'
import { useTranslation } from 'next-i18next'
import { DeleteOutlined, EditTwoTone } from '@ant-design/icons'
import { showNotification } from 'src/core/helpers'

const FootPrintListActionColumn = ({ footprint }) => {
  const { t } = useTranslation()
  const [isModalVisible, setIsModalVisible] = useState(false)
  const { loading } = useAppSelector((state) => state.footprint.updateFootPrint)
  const dispatch = useAppDispatch()

  const handleSubmit = (values) => {
    dispatch(updateFootPrint(footprint.id, values))
    setIsModalVisible(false)
    showNotification('success', t('general.OperationSuccess'))
  }

  const showModal = () => {
    setIsModalVisible(true)
  }

  const handleDelete = () => {
    dispatch(deleteFootPrint(footprint.id))
    showNotification('success', t('general.OperationSuccess'))
  }

  return (
    <div className={styles['main-container']}>
      <Button
        type='ghost'
        size='middle'
        shape='circle'
        className={`radius-100`}
        onClick={showModal}
        icon={<EditTwoTone />}
      />
      &nbsp; &nbsp;
      <Popconfirm
        title={t('general.SureDelete')}
        onConfirm={handleDelete}
        okText={t('general.Yes')}
        cancelText={t('general.Cancel')}
      >
        <Button
          danger
          size='middle'
          shape='circle'
          className='radius-100'
          icon={<DeleteOutlined />}
        />
      </Popconfirm>

      <CustomModal
        title={t('footPrint.EditRegister')}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        open={isModalVisible}
      >
        <FootPrintForm
          handleSubmit={handleSubmit}
          footPrint={footprint}
          isLoading={loading}
        />
      </CustomModal>
    </div>
  )
}

export default FootPrintListActionColumn
